import axios from 'axios';
import { FETCH_USER, KEEP_USER, LOGIN_USER } from './types';
const initialState = { key: '', name: '', userId: '', isAuth: false, forceToChangePW: false }

export const fetchUser = () => async dispatch => {
    const res = await axios.get('/api/auth/CurrentUser');
    if (res.data.data === null) {
        dispatch({ type: FETCH_USER, payload: initialState })
    }
    else if (res.data.data != null) {
        dispatch({ type: FETCH_USER, payload: res.data.data });
    }
};

export const loginUser = (username, password) => async dispatch => {
    //const res = await axios.get(`/api/login?username=${username}&password=${password}`);
    let res = await axios.post(`/api/member/Authenticate`, { username, password });
    dispatch({ type: LOGIN_USER, payload: res.data });
};

export const keepUser = (userInfo) => async dispath => {
    console.log("keep user",userInfo)
    dispath({ type: KEEP_USER, payload: userInfo });
}